exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step-configure .field[data-v-05f0a782],\n.step-configure .form-group[data-v-05f0a782] {\n  margin-bottom: 16px;\n}\n.step-configure .action-buttons[data-v-05f0a782] {\n  display: flex;\n  gap: 12px;\n  justify-content: stretch;\n}\n.step-configure .action-buttons button[data-v-05f0a782] {\n  flex: 1;\n  justify-content: center;\n}\n", ""]);

// exports
